import { useQuery } from "@tanstack/react-query";
import { customJoinPageService } from "@/services/customJoinPage.service";

export const CUSTOM_JOIN_PAGE_QUERY_KEY = ["custom-join-page", "me"] as const;

/** Shared by Settings (to show/hide the tab) and the tab itself. */
export function useCustomJoinPageState() {
  return useQuery({
    queryKey: CUSTOM_JOIN_PAGE_QUERY_KEY,
    queryFn: () => customJoinPageService.getMine(),
    staleTime: 30_000,
  });
}
